function list() {
    return {
        componentName: 'list',
        baseStyle: {
            display: 'flex',
            flexDirection: 'column'
        }
    };
}

export { list as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlzdC5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3RoZW1lL2NvbXBvbmVudHMvbGlzdC9saXN0LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbXBvbmVudFN0eWxlIH0gZnJvbSAnLi4vLi4vdHlwZXMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBsaXN0KCk6IENvbXBvbmVudFN0eWxlIHtcbiAgcmV0dXJuIHtcbiAgICBjb21wb25lbnROYW1lOiAnbGlzdCcsXG4gICAgYmFzZVN0eWxlOiB7XG4gICAgICBkaXNwbGF5OiAnZmxleCcsXG4gICAgICBmbGV4RGlyZWN0aW9uOiAnY29sdW1uJ1xuICAgIH1cbiAgfTtcbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFYyxTQUFVLElBQUksR0FBQTtJQUMxQixPQUFPO0FBQ0wsUUFBQSxhQUFhLEVBQUUsTUFBTTtBQUNyQixRQUFBLFNBQVMsRUFBRTtBQUNULFlBQUEsT0FBTyxFQUFFLE1BQU07QUFDZixZQUFBLGFBQWEsRUFBRTtBQUNoQjtLQUNGO0FBQ0g7Ozs7In0=
